import { Content } from "pdfmake/interfaces";
import layout from "report/common/layout";
import svg from "report/common/svg";
import getTitle from "report/common/title";
import {
  ClimateRiskReportSection,
  getClimateRiskLayerLabelKey
} from "../types";

const get = (t: any, sections: ClimateRiskReportSection[]): Content[] => {
  const legendSections: Content[] = sections.flatMap((section, index) => {
    const layerIds = Array.from(
      new Set(section.sspData.SSP126Arr.map((entry: any[]) => entry[0]))
    );

    if (!layerIds.length) {
      return [] as Content[];
    }

    const rows = layerIds.map((layerId) => [
      svg[layerId]
        ? {
            svg: svg[layerId],
            fit: [12, 12],
            width: 12
          }
        : { text: "" },
      {
        text: t(getClimateRiskLayerLabelKey(section.category, layerId)),
        bold: true,
        opacity: 0.6
      }
    ]);

    const content: Content[] = [
      {
        text: section.title,
        fontSize: 9,
        bold: true,
        margin: [0, index === 0 ? 0 : 8, 0, 4],
        opacity: 0.75
      } as Content,
      {
        table: {
          headerRows: 0,
          widths: ["auto", "*"],
          body: rows
        },
        layout: layout(),
        fontSize: 8
      } as Content
    ];

    return content;
  });

  return [getTitle(t("report.Risk Analyzed")), ...legendSections];
};

export default get;
